module.exports = __webpack_public_path__ + "static/media/contest2025_first_place_image.a86198c4.jpeg";